import COLORS from '../../../../../utils/constants/colors'

const dateRangeFieldStyles = {
  container: {
    marginTop: 16,
    marginBottom: 8,
  },
  button: {
    width: '100%',
    justifyContent: 'flex-start',
    padding: '10px 14px',
    textTransform: 'none',
    color: '#555555',
    borderColor: '#c4c4c4',
    '&:hover': {
      borderColor: '#000000',
    },
  },
  calendarIcon: {
    fill: COLORS.orange,
    width: 20,
    height: 20,
  },
  dateRangePickerRoot: {
    '& div': {
      boxShadow: 'unset',
    },
  },
  dialog: {},
  dialogContentRoot: {
    '&&': {
      padding: '25px 25px 5px 25px',
    },
  },
  closeIcon: {
    position: 'absolute',
    top: '12px',
    right: '12px',
    zIndex: 100,
  },
}

export default dateRangeFieldStyles
